import './formDetalle.scss'
import { useState, useEffect, useContext } from "react";
import { PedidosDetalleFormContext } from '../../../../../context/pedidosdetalle/PedidosDetalleContext';
import ArticulosModal from '../../../../articulos/articulosModal/articulosModal';
import ErrorDialog from "../../../../../components/dialogs/ErrorDialog";

export const FormDetalle = ({
  pedidoid, // oca_id
  iddet, // ocd_id
  catcli,
  closeModal,
  actualizaTotalPedido,
}) => {

  const {
    getBusquedaArticuloByIdData,
    getPedidoDetalleByIdData,
    postPedidoDetalleData,
    patchPedidoDetalleData,
    getPedidosDetallePanelData
  } = useContext(PedidosDetalleFormContext)

  const [title, setTitle] = useState('');
  const [form, setForm] = useState({
    prd_id: '',
    prd_code: '',
    art_descripcion: '',
    ocd_quantity: 1,
    ocd_price: 0,
    ocd_discount_percentage: 0,
    ocd_discount_amount: 0,
    ocd_total_amount: 0,
    ocd_iva: 0,
    ocd_impuesto_interno: 0,
    ocd_observacion: '',
    oca_id: pedidoid
  });
  const [errors, setErrors] = useState({});
  const [searchIdArt, setSearchIdArt] = useState();
  const [searchDescArt, setSearchDescArt] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [estadoForm, setEstadoForm] = useState(0);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    iddet ? setTitle('Editar Artículo del Pedido') : setTitle('Agregar Artículo al Pedido');
  }, [iddet])


  useEffect(() => {
    const fetchData = async () => {
      if (iddet) {
        try {
          const detalle = await getPedidoDetalleByIdData(iddet);
          if (detalle) {
            const articulo = await getBusquedaArticuloByIdData(detalle.prd_id);
            setForm({
              ...detalle,
              art_descripcion: articulo?.art_descripcion || '',
              prd_code: articulo?.art_codigo || detalle.prd_code || '',
            });
            setEstadoForm(1);
          } else {
            console.error("No se encontraron datos para el ID proporcionado.");
          }
        } catch (error) {
          console.error("Error al obtener los datos desde la API:", error);
        }
      }
    };

    fetchData();
  }, [iddet]);

  const handleSelectArticulo = (art_id, art_codigo, art_descripcion, art_npreciocosto, preciobuscado) => {
    const nuevoPrecio = Number(preciobuscado);
    const cantidad = Number(form.ocd_quantity) || 1;
    const descuentoPorcentaje = Number(form.ocd_discount_percentage) || 0;

    // Calcular descuento y total
    const descuentoMonto = (nuevoPrecio * cantidad * descuentoPorcentaje) / 100;
    const totalAmount = (nuevoPrecio * cantidad) - descuentoMonto;

    setForm((prevForm) => ({
      ...prevForm,
      prd_id: art_id,
      prd_code: art_codigo,
      art_descripcion: art_descripcion,
      ocd_price: nuevoPrecio.toFixed(2),
      ocd_discount_amount: descuentoMonto.toFixed(2),
      ocd_total_amount: totalAmount.toFixed(2)
    }));
  };

  const calcularTotales = (cantidad, precio, descuentoPorcentaje) => {
    const cant = Number(cantidad) || 0;
    const prec = Number(precio) || 0;
    const desc = Number(descuentoPorcentaje) || 0;

    const descuentoMonto = (prec * cant * desc) / 100;
    const totalAmount = (prec * cant) - descuentoMonto;

    return {
      ocd_discount_amount: descuentoMonto.toFixed(2),
      ocd_total_amount: totalAmount.toFixed(2)
    };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prevForm) => {
      let updatedForm = { ...prevForm, [name]: value };

      // Recalcular totales cuando cambie cantidad, precio o descuento
      if (name === 'ocd_quantity' || name === 'ocd_price' || name === 'ocd_discount_percentage') {
        const totales = calcularTotales(
          name === 'ocd_quantity' ? value : prevForm.ocd_quantity,
          name === 'ocd_price' ? value : prevForm.ocd_price,
          name === 'ocd_discount_percentage' ? value : prevForm.ocd_discount_percentage
        );
        updatedForm = { ...updatedForm, ...totales };
      }

      validateInput(name, value);
      return updatedForm;
    });
  };

  const validateInput = (name, value) => {
    let formErrors = { ...errors };

    if (name === 'prd_id' && !value) {
      formErrors.prd_id = 'Debe seleccionar un artículo';
    } else if (name === 'prd_id') {
      delete formErrors.prd_id;
    }

    if (name === 'ocd_quantity' && (!value || Number(value) <= 0)) {
      formErrors.ocd_quantity = 'La cantidad debe ser mayor a 0';
    } else if (name === 'ocd_quantity') {
      delete formErrors.ocd_quantity;
    }

    if (name === 'ocd_price' && (!value || Number(value) <= 0)) {
      formErrors.ocd_price = 'El precio debe ser mayor a 0';
    } else if (name === 'ocd_price') {
      delete formErrors.ocd_price;
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const validateForm = async () => {
    let formErrors = {};

    if (!form.prd_id) {
      formErrors.prd_id = 'Debe seleccionar un artículo';
    }

    if (!form.ocd_quantity || Number(form.ocd_quantity) <= 0) {
      formErrors.ocd_quantity = 'La cantidad debe ser mayor a 0';
    }

    if (!form.ocd_price || Number(form.ocd_price) <= 0) {
      formErrors.ocd_price = 'El precio debe ser mayor a 0';
    }

    // Verificar si hay errores de validación
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return false;
    }

    // Verificar si el artículo ya existe (solo al crear)
    if (!iddet) {
      const existente = await buscarExistente();
      if (existente) {
        formErrors.prd_code = 'El artículo ya existe en este pedido';
        setErrors(formErrors);
        return false;
      }
    }

    setErrors({});
    return true;
  };

  const buscarExistente = async () => {
    if (pedidoid && form.prd_id) {
      try {
        const encontrado = await getPedidosDetallePanelData(pedidoid, form.prd_id, 1, "1000");
        return encontrado && encontrado.length > 0;
      } catch (error) {
        console.error("Error al buscar artículo existente:", error);
        return false;
      }
    }
    return false;
  };

  const handleSendData = async () => {
    // Validar formulario
    const isFormValid = await validateForm();
    if (!isFormValid) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }

    setIsSubmitting(true);

    try {
      const dataToSend = {
        prd_id: form.prd_id,
        prd_code: form.prd_code,
        ocd_quantity: Number(form.ocd_quantity),
        ocd_price: Number(form.ocd_price),
        ocd_discount_percentage: Number(form.ocd_discount_percentage),
        ocd_discount_amount: Number(form.ocd_discount_amount),
        ocd_total_amount: Number(form.ocd_total_amount),
        ocd_iva: Number(form.ocd_iva) || 0,
        ocd_impuesto_interno: Number(form.ocd_impuesto_interno) || 0,
        ocd_observacion: form.ocd_observacion || '',
        oca_id: pedidoid
      };
      if (iddet) {
        // Editar
        await patchPedidoDetalleData(iddet, dataToSend);
        actualizaTotalPedido();
      } else {
        // Crear nuevo
        await postPedidoDetalleData(dataToSend);
        actualizaTotalPedido();
      }

      resetForm();
      closeModal();
    } catch (error) {
      console.error("Error al guardar los datos:", error);
      openErrorDialog("Error al guardar el artículo. Por favor, intente nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const resetForm = () => {
    setForm({
      prd_id: '',
      prd_code: '',
      art_descripcion: '',
      ocd_quantity: 1,
      ocd_price: 0,
      ocd_discount_percentage: 0,
      ocd_discount_amount: 0,
      ocd_total_amount: 0,
      ocd_iva: 0,
      ocd_impuesto_interno: 0,
      ocd_observacion: '',
      oca_id: pedidoid
    });
    setErrors({});
    setEstadoForm(0);
  };

  const handleCancel = () => {
    resetForm();
    closeModal();
  };

  return (
    <>
      <div className="titleOCD">
        <h3>{title}</h3>
      </div>

      <div className="containerOCD">
        <div className="cardOCD">
          <form className="formOCD">

            {/* Búsqueda */}
            {estadoForm !== 1 && (
              <div className="fieldGroupOCD">
                <label className="labelOCD">Búsqueda de Artículo</label>
                <ArticulosModal
                  handleChange={setSearchIdArt}
                  handleDescChange={setSearchDescArt}
                  descSelected={searchIdArt}
                  onSelect={handleSelectArticulo}
                  tipoprecio={catcli}
                />
              </div>
            )}

            {/* Código */}
            <div className="fieldGroupOCD">
              <label className="labelOCD">Código</label>
              <input
                type="text"
                name="prd_code"
                value={form.prd_code || ''}
                placeholder="Código del artículo"
                className={`inputOCD inputReadOnlyOCD ${errors["prd_code"] ? 'inputErrorOCD' : ''}`}
                readOnly
              />
              {errors["prd_code"] && <span className="errorOCD">{errors["prd_code"]}</span>}
            </div>

            {/* Descripción */}
            <div className="fieldGroupOCD">
              <label className="labelOCD">Descripción del Artículo</label>
              <input
                type="text"
                name="art_descripcion"
                value={form.art_descripcion || ''}
                placeholder="Descripción"
                className={`inputOCD inputReadOnlyOCD ${errors["art_descripcion"] ? 'inputErrorOCD' : ''}`}
                readOnly
              />
              {errors["art_descripcion"] && <span className="errorOCD">{errors["art_descripcion"]}</span>}
            </div>

            {/* Cantidad */}
            <div className="fieldGroupOCD">
              <label className="labelOCD">Cantidad</label>
              <input
                type="number"
                name="ocd_quantity"
                value={form.ocd_quantity || ''}
                placeholder="Cantidad"
                className={`inputOCD ${errors["ocd_quantity"] ? 'inputErrorOCD' : ''}`}
                onChange={handleInputChange}
                min="1"
              />
              {errors["ocd_quantity"] && <span className="errorOCD">{errors["ocd_quantity"]}</span>}
            </div>

            {/* Precio */}
            <div className="fieldGroupOCD">
              <label className="labelOCD">Precio Unitario</label>
              <input
                type="number"
                name="ocd_price"
                value={form.ocd_price || ''}
                placeholder="Precio"
                className={`inputOCD inputReadOnlyOCD ${errors["ocd_price"] ? 'inputErrorOCD' : ''}`}
                readOnly
              />
              {errors["ocd_price"] && <span className="errorOCD">{errors["ocd_price"]}</span>}
            </div>

            {/* Descuento % */}
            <div className="fieldGroupOCD">
              <label className="labelOCD">Descuento (%)</label>
              <input
                type="number"
                name="ocd_discount_percentage"
                value={form.ocd_discount_percentage || ''}
                placeholder="Descuento %"
                className={`inputOCD ${errors["ocd_discount_percentage"] ? 'inputErrorOCD' : ''}`}
                onChange={handleInputChange}
                min="0"
                max="100"
              />
              {errors["ocd_discount_percentage"] && <span className="errorOCD">{errors["ocd_discount_percentage"]}</span>}
            </div>

            {/* Descuento Monto */}
            <div className="fieldGroupOCD">
              <label className="labelOCD">Descuento (Monto)</label>
              <input
                type="number"
                name="ocd_discount_amount"
                value={form.ocd_discount_amount || ''}
                placeholder="Descuento calculado"
                className="inputOCD inputReadOnlyOCD"
                readOnly
              />
            </div>

            {/* Total */}
            <div className="fieldGroupOCD">
              <label className="labelOCD">Total</label>
              <input
                type="number"
                name="ocd_total_amount"
                value={form.ocd_total_amount || ''}
                placeholder="Total calculado"
                className="inputOCD inputReadOnlyOCD"
                readOnly
              />
            </div>

            {/* Observación */}
            <div className="fieldGroupOCD fullWidthOCD">
              <label className="labelOCD">Observación</label>
              <textarea
                name="ocd_observacion"
                value={form.ocd_observacion || ''}
                placeholder="Observaciones"
                className={`textareaOCD ${errors["ocd_observacion"] ? 'inputErrorOCD' : ''}`}
                onChange={handleInputChange}
                rows="3"
              />
              {errors["ocd_observacion"] && <span className="errorOCD">{errors["ocd_observacion"]}</span>}
            </div>

            {/* Botones */}
            <div className="buttonGroupOCD">
              <button
                type="button"
                className="buttonPrimaryOCD"
                onClick={handleSendData}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Guardando...' : 'Guardar'}
              </button>

              <button
                type="button"
                className="buttonSecondaryOCD"
                onClick={handleCancel}
                disabled={isSubmitting}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </>

  );
};

export default FormDetalle;